module.exports = __webpack_public_path__ + "media/images/area/maps/kansai-58ab89a5a8290edbdee3841b171aa2dd.svg";